export const CommonPageTypes = {
  NOT_FOUND: "PAGE_NOT_FOUND",
};



// WEBPACK FOOTER //
// ./src/lib/routing/constants.js